import { toWesternDigits } from './westernDigits';

function formatAbsoluteDate(d: Date): string {
  const raw = d.toLocaleDateString('ar-SA-u-nu-latn', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
  return toWesternDigits(raw);
}

/**
 * عرض وقت التقييم: نسبي حتى أسبوع، ثم تاريخ كامل بأرقام 0123456789.
 * - دقائق / ساعات / أيام 1–6 / «منذ أسبوع» لليوم السابع / تاريخ بعد ذلك.
 */
export function formatRelativeReviewTime(iso: string, now: Date = new Date()): string {
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return '';

  const diffMs = now.getTime() - then.getTime();
  if (diffMs < 0) return formatAbsoluteDate(then);

  const minute = 60_000;
  const hour = 60 * minute;
  const dayMs = 24 * hour;

  const totalDays = Math.floor(diffMs / dayMs);

  if (totalDays > 7) {
    return formatAbsoluteDate(then);
  }
  if (totalDays === 7) {
    return 'منذ أسبوع';
  }
  if (totalDays === 6) {
    return 'منذ 6 أيام';
  }
  if (totalDays === 5) {
    return 'منذ 5 أيام';
  }
  if (totalDays === 4) {
    return 'منذ 4 أيام';
  }
  if (totalDays === 3) {
    return 'منذ 3 أيام';
  }
  if (totalDays === 2) {
    return 'منذ 2 يوم';
  }
  if (totalDays === 1) {
    return 'منذ 1 يوم';
  }

  if (diffMs < minute) {
    return 'منذ أقل من دقيقة';
  }

  const mins = Math.floor(diffMs / minute);
  if (diffMs < hour) {
    return mins === 1 ? 'منذ 1 دقيقة' : `منذ ${mins} دقيقة`;
  }

  const hours = Math.floor(diffMs / hour);
  return hours === 1 ? 'منذ 1 ساعة' : `منذ ${hours} ساعة`;
}
